export default "__VITE_ASSET__fvW4coAj__"